import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=b5bd2df6&scoped=true&lang=pug&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=b5bd2df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd2df6",
  null
  
)

export default component.exports